import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { colors, getResetByTag } from './../../../styles';
var defaultStyles = function defaultStyles(_ref) {
  var isInverse = _ref.isInverse;
  return /*#__PURE__*/css("color:", isInverse ? colors.white : colors.coolGray_900, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var resetStyles = getResetByTag('span');
var StyledFormOptionAsterisk = /*#__PURE__*/_styled('span', process.env.NODE_ENV === "production" ? {
  target: "esupjv00"
} : {
  target: "esupjv00",
  label: "StyledFormOptionAsterisk"
})(resetStyles, defaultStyles);
export default StyledFormOptionAsterisk;